"use strict";

import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
import _inherits from "@babel/runtime/helpers/inherits";
import { Messages } from "Messages";
import BlankControl from "./BlankControl";

var IsNotBlankControl =
/*#__PURE__*/
function (_BlankControl) {
  _inherits(IsNotBlankControl, _BlankControl);

  function IsNotBlankControl() {
    _classCallCheck(this, IsNotBlankControl);

    return _possibleConstructorReturn(this, _getPrototypeOf(IsNotBlankControl).apply(this, arguments));
  }

  _createClass(IsNotBlankControl, [{
    key: "render",
    value: function render() {
      this.$_element.text(Messages.Controls.IsNotBlank);
    }
  }]);

  return IsNotBlankControl;
}(BlankControl);

export { IsNotBlankControl as default };